import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/components/base/base-form.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MessageModel } from 'src/app/shared/models/domain/message.model';
import { ClientModel } from 'src/app/shared/models/domain/client.model';
import { MessageService } from 'src/app/core/services/domain/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-message-form',
  templateUrl: './message-form.component.html',
  styleUrls: ['./message-form.component.scss']
})
export class MessageFormComponent extends BaseFormComponent<MessageModel> implements OnInit, AfterViewInit {
  @Output() recipientChange = new EventEmitter<string>();

  recipients: ClientModel[] = null;
  editor = null;
  editorConfig: any = null;
  readonly tinyMceLicenseKey: string = environment.tinyMceLicenseKey;


  constructor(private messageService: MessageService, private elementRef :ElementRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.messageService.listRecipients(this.value.business.businessKey).subscribe(recipients => {
      this.recipients = recipients;
    });
  }

  onRecipientChanged(): void {
    this.recipientChange.emit(this.value.recipient.clientKey);
  }

  ngAfterViewInit(): void {
    setTimeout(_ => {
      let height = this.elementRef.nativeElement.offsetHeight;

      if (height < 250) {
        height = 250;
      }

      this.editorConfig = {
        menubar: true,
        height: height,
        width: '100%',
        setup: (editor) => {
          this.editor = editor;
        },
        paste_data_images: true,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor paste',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
      }
    });
  }

  protected getFormGroup(): UntypedFormGroup {
    return new UntypedFormGroup({
      messageKey: new UntypedFormControl(this.value?.messageKey),
      business: new UntypedFormControl(this.value?.business),

      subject: new UntypedFormControl(this.value?.subject),
      htmlContent: new UntypedFormControl(this.value?.htmlContent),

      recipientReadDateTime: new UntypedFormControl(this.value?.recipientReadDateTime),
      createdDateTime: new UntypedFormControl(this.value?.createdDateTime),

      recipient: new UntypedFormGroup({
        clientKey: new UntypedFormControl(this.value?.recipient?.clientKey),
        lastName: new UntypedFormControl(this.value?.recipient?.lastName),
        firstName: new UntypedFormControl(this.value?.recipient?.firstName)
      }),
      sender: new UntypedFormGroup({
        clientKey: new UntypedFormControl(this.value?.sender?.clientKey),
        lastName: new UntypedFormControl(this.value?.sender?.lastName),
        firstName: new UntypedFormControl(this.value?.sender?.firstName)
      })
    });
  };
}
